import styled from 'styled-components'

export const StyledLogo = styled.div`
  color: #162954;
  display: inline-grid;
  align-items: center;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  .logo-img {
    height: 65px;
    user-select: none;
  }
  .logo-text {
    font-size: 32px;
    font-weight: 800;
  }
`;